<div class="table-responsive">
  <div><button mat-raised-button class="createButton" color="accent" (click)="createPrinter()">POS Drucker erstellen</button></div>
  <mat-form-field>
    <mat-label>Tenant filtern</mat-label>
    <mat-select (selectionChange)="applyFilter($event.value)">
      <mat-option *ngFor="let printer of printerFilterValues" [value]="printer">{{ printer }}</mat-option>
    </mat-select>
  </mat-form-field>
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
    <!-- Columns for Order interface -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Name</th>
      <td mat-cell *matCellDef="let printer">{{ printer.name }}</td>
    </ng-container>

    <ng-container matColumnDef="location">
      <th mat-header-cell *matHeaderCellDef>Position</th>
      <td mat-cell *matCellDef="let printer">{{ printer.location }}</td>
    </ng-container>

    <ng-container matColumnDef="ipAddress">
      <th mat-header-cell *matHeaderCellDef>IP-Adresse</th>
      <td mat-cell *matCellDef="let printer">{{ printer.ipAddress }}</td>
    </ng-container>

    <ng-container matColumnDef="port">
      <th mat-header-cell *matHeaderCellDef>Port</th>
      <td mat-cell *matCellDef="let printer">{{ printer.port }}</td>
    </ng-container>

    <ng-container matColumnDef="printCategoryIdentifier">
      <th mat-header-cell *matHeaderCellDef>Print Category Identifier</th>
      <td mat-cell *matCellDef="let printer">{{ printer.printCategoryIdentifier }}</td>
    </ng-container>

    <ng-container matColumnDef="tenantName">
      <th mat-header-cell *matHeaderCellDef>Tenant Name</th>
      <td mat-cell *matCellDef="let printer">{{ printer.tenantName }}</td>
    </ng-container>

    <ng-container matColumnDef="backupForOtherCategories">
      <th mat-header-cell *matHeaderCellDef>Backup</th>
      <td mat-cell *matCellDef="let printer">{{ printer.backupForOtherCategories | yesNo }}</td>
    </ng-container>

    <ng-container matColumnDef="details">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let printer">
        <button mat-icon-button (click)="showPrinterDetails(printer)">
          <mat-icon>edit</mat-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="delete">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let printer">
        <button mat-icon-button (click)="deletePrinter(printer)">
          <mat-icon>delete</mat-icon>
        </button>
      </td>
    </ng-container>

    <!-- Define the displayed columns order -->
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let printer; columns: displayedColumns;"></tr>
  </table>
</div>
